import { Component, input } from '@angular/core';

@Component({
  selector: 'ez-info-popover',
  imports: [],
  templateUrl: './info-popover.component.html',
  styleUrl: './info-popover.component.scss',
})
export class InfoPopoverComponent {
  readonly popoverText = input.required<string>();
}
